module.exports = __webpack_public_path__ + "assets/img/tsgn1.7aad65c6.jpg";